// removed by extract-text-webpack-plugin
module.exports = {"project":"ProjectOverview__project__3hyrv","readMore":"ProjectOverview__readMore__39zMN"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ProjectOverview/ProjectOverview.scss
// module id = 125
// module chunks = 0